import { defineStore } from 'pinia';
import type { TextModeAlertState } from '../types/text-mode.types';

export type TextModeAlertType = 'comprehensive' | 'not_clinical' | 'no_focused_logic';

export function resolveTextModeAlertType(
    alertState: TextModeAlertState,
): TextModeAlertType | null {
    if (alertState.isNotClinicalConcept) return 'not_clinical';
    if (alertState.isNoFocusedLogic) return 'no_focused_logic';
    if (alertState.isComprehensive) return 'comprehensive';
    return null;
}

export interface AlertStoreState extends TextModeAlertState {
    needsReEvaluation: boolean;
}

function createInitialAlertState(): AlertStoreState {
    return {
        isNotClinicalConcept: false,
        isComprehensive: false,
        isNoFocusedLogic: false,
        needsReEvaluation: false,
    }
}

export const useAlertStore = defineStore('textModeAlert', {
    state: (): AlertStoreState => createInitialAlertState(),

    getters: {
        hasAnyAlert: (state): boolean =>
            state.isNotClinicalConcept || state.isNoFocusedLogic,
        activeAlertType: (state): TextModeAlertType | null => resolveTextModeAlertType(state),
    },

    actions: {

        buildAlertsFromResponse(response: TextModeAlertState): void {
            this.isNotClinicalConcept = response.isNotClinicalConcept;
            this.isComprehensive = response.isComprehensive;
            this.isNoFocusedLogic = response.isNoFocusedLogic;
            // Clear needsReEvaluation when we get a fresh response from backend
            // (re-evaluation has occurred)
            this.needsReEvaluation = false;
        },

        setNeedsReEvaluation(value: boolean): void {
            this.needsReEvaluation = value;
        },

        reset(): void {
            Object.assign(this, createInitialAlertState());
        },

        resume(payload: AlertStoreState): void {
            Object.assign(this, payload);
        },
    },
});
